import React from 'react';
import PropTypes from 'prop-types';
import './DropDown.scss';
import autoBind from 'react-autobind';

export default class DropDown extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    if (props.values === undefined || props.values < 1) {
      console.error('values must be supplied, given undefined or empty array');
    }
    if (!props.onChange || typeof props.onChange !== 'function') {
      console.error(`Either onChange call back was not supplied,
                or onChange is not a function!`);
    }
  }

  onChange(selectedValue) {
    this.props.onChange(selectedValue);
  }

  render() {
    const { values, menuAlignment = 'right' } = this.props;
    const classAlignemt = `dropdown-menu-${menuAlignment}`;
    const selected = this.props.defaultSelected || this.props.values[0];
    const className = (selected && selected.className) || '';

    return (
      <div className='dropdown-container cf'>
        <div className='btn-group padTop'>
          <button
            className={`btn btn-secondary dropdown-toggle ${className}`}
            type='button'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <span className='selected-value'>{selected.displayText}</span>
          </button>
          <div
            className={`dropdown-menu ${classAlignemt}`}
            aria-labelledby='dropdownMenuButton'
          >
            {values.map((value, index) => {
              if (typeof value === 'function') {
                return value();
              }
              const valueClassName = value.className || '';
              return (
                <a
                  className='dropdown-item'
                  href='#'
                  key={index}
                  onClick={(event) => {
                    event.preventDefault();
                    this.onChange(value);
                  }}
                >
                  <span
                    className={`dropdown-item--value ${valueClassName}`}
                    value={value.id}
                  >
                    {value.displayText}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

DropDown.propTypes = {
  defaultSelected: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
  menuAlignment: PropTypes.string,
};
